class ProxyService {
  constructor() {
    this.proxyBaseUrl = process.env.REACT_APP_PROXY_URL || 'http://iptv.hmldev.com.br/api/proxy';
    this.fallbackProxies = [
      'https://cors-anywhere.herokuapp.com',
      'https://api.allorigins.win/raw?url=',
      'https://corsproxy.io/?'
    ];
  }

  async makeProxiedRequest(url, options = {}) {
    const proxiedUrl = `${this.proxyBaseUrl}?url=${encodeURIComponent(url)}`;
    
    try {
      console.log(`Fazendo requisição via proxy: ${proxiedUrl}`);
      
      const response = await fetch(proxiedUrl, {
        method: options.method || 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          ...options.headers
        },
        ...options
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      return response;
    } catch (error) {
      console.error('Erro na requisição via proxy principal:', error);
      return this.tryFallbackProxies(url, options);
    }
  }

  async tryFallbackProxies(url, options = {}) {
    for (const proxyUrl of this.fallbackProxies) {
      try {
        console.log(`Tentando proxy alternativo: ${proxyUrl}`);
        
        let proxiedUrl;
        if (proxyUrl.includes('allorigins.win')) {
          proxiedUrl = `${proxyUrl}${encodeURIComponent(url)}`;
        } else {
          proxiedUrl = `${proxyUrl}${url}`;
        }

        const response = await fetch(proxiedUrl, {
          method: options.method || 'GET',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            ...options.headers
          },
          ...options
        });

        if (response.ok) {
          console.log(`Sucesso com proxy: ${proxyUrl}`);
          return response;
        }
      } catch (error) {
        console.error(`Erro com proxy ${proxyUrl}:`, error);
        continue;
      }
    }
    
    throw new Error('Todos os proxies falharam');
  }

  convertHttpToHttps(url) {
    if (!url) return url;
    
    if (url.startsWith('http://')) {
      const httpsUrl = url.replace('http://', 'https://');
      console.log(`Convertendo URL para HTTPS: ${httpsUrl}`);
      return httpsUrl;
    }
    
    return url;
  }

  async getM3UContent(m3uUrl) {
    try {
      console.log(`Carregando M3U via proxy: ${m3uUrl}`);
      
      const response = await this.makeProxiedRequest(m3uUrl);
      const content = await response.text();
      
      console.log(`M3U carregado com sucesso. Tamanho: ${content.length} caracteres`);
      return content;
    } catch (error) {
      console.error('Erro ao carregar M3U via proxy:', error);
      throw new Error(`Falha ao carregar lista de canais: ${error.message}`);
    }
  }

  async getEPGContent(epgUrl) {
    try {
      console.log(`Carregando EPG via proxy: ${epgUrl}`);
      
      const response = await this.makeProxiedRequest(epgUrl);
      const content = await response.text();
      
      console.log(`EPG carregado com sucesso. Tamanho: ${content.length} caracteres`);
      return content;
    } catch (error) {
      console.error('Erro ao carregar EPG via proxy:', error);
      throw new Error(`Falha ao carregar guia de programação: ${error.message}`);
    }
  }

  getProxiedStreamUrl(originalUrl) {
    if (!originalUrl) return originalUrl;
    
    if (originalUrl.startsWith('http://')) {
      const proxiedUrl = `${this.proxyBaseUrl}/stream?url=${encodeURIComponent(originalUrl)}`;
      console.log(`URL de stream via proxy: ${proxiedUrl}`);
      return proxiedUrl;
    }
    
    return originalUrl;
  }

  isHttpsRequired() {
    return window.location.protocol === 'https:';
  }

  shouldUseProxy(url) {
    return this.isHttpsRequired() && url && url.startsWith('http://');
  }
}

const proxyService = new ProxyService();
export default proxyService; 